import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';

@Component({
  selector: 'app-registration-flow',
  standalone: false,
  templateUrl: './registration-flow.component.html',
  styleUrl: './registration-flow.component.scss',
})
export class RegistrationFlowComponent {
  @Input() allowAddingEmployees: boolean = false;
  @Output() allowAddingEmployeesChange = new EventEmitter<boolean>();
  
  @Input() createLocationAutomatically: boolean = false;
  @Output() createLocationAutomaticallyChange = new EventEmitter<boolean>();

  @Input() parentLocationId: string | null = null;
  @Output() parentLocationIdChange = new EventEmitter<string | null>();

  @Input()
  locations: OrganisationUnitModel[] = [];
  
  get parentLocation(): OrganisationUnitModel | null {
    if (!this.parentLocationId) 
      return null;

    return this.locations
      .find(l => l.id == this.parentLocationId) ?? null;
  }

  onAllowAddingEmployeesChanged(enabled: boolean): void {
    this.allowAddingEmployeesChange.emit(enabled);

    if (!enabled) {
      this.createLocationAutomaticallyChange.emit(false);
      this.parentLocationIdChange.emit(null);
    }
  }

  onCreateLocationAutomaticallyChanged(enabled: boolean): void {
    this.createLocationAutomaticallyChange.emit(enabled);                                 

    if (!enabled) {
      this.parentLocationIdChange.emit(null);
    }
  }

  onParentLocationChanged(e: any) {
    const locationId = e.node.key ?? null;
    this.parentLocationId = locationId;
    this.parentLocationIdChange.emit(locationId);
  }
}
